import styled from 'styled-components'

export const ParcelCardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp12};
  gap: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const ParcelInfo = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ParcelInfoContainer = styled.div`
  display: flex;
  align-items: ${props => props.alignItems};
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const OriginAndDestinationContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
